// src/components/InvoiceViewerSelector.jsx
import React, { useContext } from "react";
import { UserContext } from "../context/UserContext";

import DefaultInvoiceViewer from "./invoiceTemplates/PDFviewer";
import ClinicInvoiceViewer from "./invoiceTemplates/ClinicInvoiceViewer";
import {
  ModernBlueInvoice,
  LuxuryBlackInvoice,
  MinimalCleanInvoice,
  WarmCreativeInvoice,
} from "./invoiceTemplates/PDFviewer_4_customer_versions";

const InvoiceViewerSelector = () => {
  const { user } = useContext(UserContext);

  console.log(user.invoiceTemplate);

  if (!user) {
    return null;
  }

  const templateMap = {
    default: DefaultInvoiceViewer,
    clinic: ClinicInvoiceViewer,
    northern: ModernBlueInvoice,
    gateway: LuxuryBlackInvoice,
    jumi: WarmCreativeInvoice,
    tm: MinimalCleanInvoice,
  };

  const SelectedViewer =
    templateMap[user.invoiceTemplate] || DefaultInvoiceViewer;

  return <SelectedViewer />;
};

export default InvoiceViewerSelector;
